
<h3 class="greeting accent">{{'MSG.GREETING' | translate}}</h3>
<small class="login-title accent">{{'LABEL.RSYAP' | translate}}</small>

<form [formGroup]="formCode" class="flex-col lt" (ngSubmit)="onVerify()">
    <label class="text-light label-control" for="code">{{'LABEL.FORGET_PWD_CODE' | translate}}</label>
    <mat-form-field color="accent" appearance="outline">
        <input formControlName="code" id="code" type="text" matInput required
            [placeholder]="'LABEL.FORGET_PWD_CODE' | translate | titlecase">
        <mat-icon matPrefix>password</mat-icon>
    </mat-form-field>
    <mat-error @fadeOpInOut *ngIf="code.hasError('invalid') && code.touched">{{ 'MSG.INVALID_CODE' | translate }}</mat-error>

    <div class="tools">
        <p *ngIf="counter; else sendCodeLbl" @fadeOpInOut>{{ 'MSG.CODE_AGAIN_IN' | translate }} {{ counter }} {{'LABEL.SECONDS' | translate}}</p>
        <ng-template #sendCodeLbl>
            <p>{{'LABEL.DONT_RECIVED_CODE' | translate}} <a class="accent" type="button" (click)="resendCode()">{{'LABEL.SEND_CODE_AGAIN' | translate}}</a></p>
        </ng-template>
        <p>{{'GLOBAL.CHECK_MAIL' | translate}}</p>
    </div>
    <button color="accent" mat-flat-button type="submit" class="submit">
        {{'LABEL.VERIFY_CODE' | translate}} <mat-icon>send</mat-icon>
    </button>
</form>

<div class="alert">
	<!-- <p class="lt">{{'MSG.DONT_HAVE_ACC' | translate}} 
		<a class="accent" routerLink="/auth/register">
			{{'LABEL.REGISTER_HERE' | translate}}
		</a>
	</p> -->
	<p class="lt">{{'MSG.HAVE_ACC' | translate}} 
		<a class="accent" routerLink="/auth/login">
			{{'LABEL.LOGIN' | translate}}
		</a>
	</p>
</div>